// Copyright 2022, Imprivata, Inc.  All rights reserved.

export enum HandoffTokenStatus {
  Pending = "Pending",
  Started = "Started",
  Completed = "Completed",
}
